<template>
    <div class="overflow-hidden">


        <svg class="h-80 w-auto lg:w-full lg:h-auto" viewBox="0 0 1706 565" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_dd_1092_2839)">
                <path
                    d="M276.149 518.841C168.707 520.893 34.1736 528.327 -30 558.103V3H1739V505.622C1664.26 535.398 1619.43 558.103 1545.19 558.103C1452.39 558.103 1351.74 522.895 1201.39 512.984C1097.07 506.108 778.943 562.479 644.64 559.915C510.336 557.351 410.453 516.277 276.149 518.841Z"
                    fill="currentColor" />
            </g>
            <defs>
                <filter id="filter0_dd_1092_2839" x="-34" y="0"  filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                    <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1092_2839" />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="1.5" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1092_2839" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                    <feBlend mode="normal" in2="effect1_dropShadow_1092_2839" result="effect2_dropShadow_1092_2839" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1092_2839" result="shape" />
                </filter>
        </defs>
    </svg>

</div></template>